import { v4 as uuidv4 } from 'uuid';
export const sessionID = uuidv4() + '-' + Date.now()
